import { useRef } from 'preact/hooks';

/**
 * Creates singleton whose factory is never re-run
 */
export function useFactory<T>(fn: () => T) {
    const ref = useRef<T>();
    if (!ref.current) {
        ref.current = fn();
    }
    return ref.current;
}
